import i18n from "i18n-js"



export const useKinventInput = () => {
  return (
    [
      {
        name: 'email',
        label: i18n.t('cruds.medicalCenters.form.email'),
        //   style: classes.addres,
      },
      {
        name: 'password',
        type: 'password',
        label: i18n.t('form.fieldPassword'),
      },
    ]
  )
} 